module.exports = __webpack_public_path__ + "assets/images/project/head/Faye_Simanjuntak.jpg?v=e6059169";